// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Benutzer, BenutzerDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateBenutzer(): (
  benutzerId: string,
  requestBody: BenutzerDaten
) => Promise<Benutzer> {
  const getAPI = useGetApi();
  return useCallback(
    async (benutzerId, requestBody) =>
      (await getAPI()).benutzer.updateBenutzer({ benutzerId, requestBody }),
    [getAPI]
  );
}
